
import React from "react";
import { useTranslation } from "react-i18next";
import "./Hero.css";
import ParticlesBackground from "../components/ParticlesBackground";
import { motion } from "framer-motion";

const Hero = () => {
  const { t } = useTranslation();

  return (
    <section className="hero">
      <ParticlesBackground />
      <div className="hero-overlay" />
      <div className="hero-content">
        <h1>{t("hero.title")}</h1>
        <p>{t("hero.subtitle")}</p>
        <a href="/contact" className="cta-button">
          {t("hero.button")}
        </a>
      </div>
    </section>
  );
};

export default Hero;
